(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3687,5742],{

/***/ 64739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22467);
/* harmony import */ var common_utils_membership__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77063);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37975);
/* harmony import */ var store_timeline__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12800);
/* harmony import */ var store_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8405);
/* harmony import */ var _PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93213);
/* harmony import */ var _PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67027);
/* harmony import */ var _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38367);











// FIXME: change isWhite to isAudioPlayer
var PlayerRateOptions = function(param) {
    var setPlaybackRate = param.setPlaybackRate, _isWhite = param.isWhite, isWhite = _isWhite === void 0 ? false : _isWhite, clickCallback = param.clickCallback;
    var currentUser = (0,store_timeline__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(state) {
        return state.currentUser;
    });
    var setShowMembershipPayDialog = (0,store_global__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    var currentAuth = (0,store_global__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.currentAuth;
    });
    var showLogin = (0,store_global__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.showLogin;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: common_utils__WEBPACK_IMPORTED_MODULE_2__/* .ALL_PLAYER_RATES.map */ .XH.map(function(rate, index) {
            var isVip = rate.isVip && !(0,common_utils_membership__WEBPACK_IMPORTED_MODULE_3__/* .canUseOption */ .Yg)(currentUser, rate.vipPackage);
            var _obj;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                onClick: function() {
                    (0,_amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_8__/* .track */ .j)("Change ".concat(isWhite ? "Audio" : "Video", " Play Speed"));
                    (0,common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .addEvent */ .vP)({
                        action: common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .EventAction.Click */ .AO.Click,
                        category: common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .EventCategory.Membership */ .Jk.Membership,
                        screen: common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .ScreenName.PostDetail */ .CG.PostDetail,
                        component: isWhite ? common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .EventComponent.AudioPlayer */ .Br.AudioPlayer : common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .EventComponent.VideoPlayer */ .Br.VideoPlayer,
                        timestamp: new Date().toISOString(),
                        tracking_params: [
                            {
                                label: "speed_rate",
                                value: rate.rate.toString()
                            }, 
                        ]
                    });
                    if (isVip) {
                        if (!currentAuth) {
                            showLogin({});
                            return;
                        }
                        setShowMembershipPayDialog({
                            open: true,
                            showMembershipStatus: false,
                            initPackage: rate.vipPackage,
                            screen: common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .ScreenName.PostDetail */ .CG.PostDetail
                        });
                        clickCallback && clickCallback();
                        return;
                    }
                    setPlaybackRate(rate.rate);
                },
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, (_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().isVip), isVip), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, (_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().isMembership), (0,common_utils_membership__WEBPACK_IMPORTED_MODULE_3__/* .isGoldMember */ .Ic)(currentUser)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, (_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().isWhite), isWhite), _obj)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().content),
                        children: [
                            rate.rate,
                            "x"
                        ]
                    }),
                    isVip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                            name: "".concat(rate.vipPackage, "-vip-icon"),
                            height: 22,
                            width: 22
                        })
                    })
                ]
            }, "option-".concat(index));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayerRateOptions);


/***/ }),

/***/ 94895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ uploadMedia; },
/* harmony export */   "D": function() { return /* binding */ MediaType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87066);



var MediaType;
(function(MediaType) {
    MediaType["Image"] = "image";
    MediaType["Video"] = "video";
    MediaType["Link"] = "link";
    MediaType["Audio"] = "audio";
})(MediaType || (MediaType = {}));
var uploadMedia = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
        var formData;
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    formData = new FormData();
                    formData.append("file", file);
                    _ctx.next = 4;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/media/", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    });
                case 4:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function uploadMedia(file) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 93213:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"PlayerRateOptions_text__cZaTl","content":"PlayerRateOptions_content__NkOeL","isWhite":"PlayerRateOptions_isWhite__N3NWW","icon":"PlayerRateOptions_icon__aseI3","isMembership":"PlayerRateOptions_isMembership__aPiqp","isVip":"PlayerRateOptions_isVip__5BvyG"};

/***/ })

}]);